'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocationInput = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _framework7React = require('framework7-react');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _logging = require('../lib/logging');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  error: {
    fontSize: '10px',
    color: 'white',
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
    textAlign: 'right',
    paddingLeft: '3px',
    paddingRight: '3px',
    backgroundColor: '#ef2d26',
    borderRadius: '4px'
  },
  geosuggest: {
    input: {},
    suggests: {
      listStyleType: 'none',
      padding: '0px 5px',
      margin: 0
    },
    suggestItem: {
      height: '45px',
      lineHeight: '45px',
      borderBottom: 'solid 1px #eeeeee',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }
  }
};

var Geosuggest = void 0;

var LocationInput = function (_Component) {
  _inherits(LocationInput, _Component);

  function LocationInput(props) {
    _classCallCheck(this, LocationInput);

    // Import only if instantiated
    var _this = _possibleConstructorReturn(this, (LocationInput.__proto__ || Object.getPrototypeOf(LocationInput)).call(this, props));

    _this.onSuggestSelect = function (data) {
      var init = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!data.gmaps) {
        (0, _logging.warn)('onSuggestSelect: gmaps is null');
        return;
      }

      var address_components = data.gmaps.address_components;


      var fields = address_components.reduce(function (acc, c) {
        return _extends({}, acc, _defineProperty({}, c.types[0], c.long_name));
      }, _extends({}, data.location));

      if (!fields.locality) {
        fields.locality = fields.administrative_area_level_3;
      }

      if (!fields.street_number) {
        // if is required, do not use default value
        var streetNumberItem = _lodash2.default.find(_this.props.items, { locationField: 'street_number' });
        var isRequired = streetNumberItem && streetNumberItem.isRequired;
        fields.street_number = !isRequired ? 'n/d' : fields.street_number;
      }

      ['route', 'street_number', 'postal_code', 'locality', 'country', 'lat', 'lng'].forEach(function (locationField) {
        if (!fields[locationField]) {
          fields[locationField] = '';
        }
      });

      var address = {
        city: fields.locality,
        route: fields.route,
        street_number: fields.street_number,
        country: fields.country
      };

      var location = {
        latitude: fields.lat,
        longitude: fields.lng
      };

      _this.setState({ fields: fields, address: address, location: location });
      _this.props.onChange({ fields: fields, address: address, location: location });
    };

    _this.renderSingleFieldSections = function (addressFields) {

      var singleFieldList = addressFields.map(function (item, key) {

        var value = typeof _this.state.fields[item.locationField] === 'string' ? _this.state.fields[item.locationField] : item.initialValue;

        var errorMap = _this.props.errors.reduce(function (acc, next) {
          var splitted = next.split(':');
          var key = splitted[0];
          var value = splitted[1];
          return _extends({}, acc, _defineProperty({}, key, value));
        }, {});

        return _react2.default.createElement(
          _framework7React.ListItem,
          { key: key, className: (0, _classnames2.default)({ hidden: item.hidden }) },
          _react2.default.createElement(
            _framework7React.FormLabel,
            null,
            item.label
          ),
          _react2.default.createElement(_framework7React.FormInput, {
            type: 'text',
            name: item.locationField,
            placeholder: item.label,
            value: value,
            onChange: function onChange(_ref) {
              var target = _ref.target;

              _this.setState(function () {
                return {
                  fields: _extends({}, _this.state.fields, _defineProperty({}, item.locationField, target.value))
                };
              }, function () {
                var fields = _this.state.fields;

                var fullAddress = fields.route + ', ' + fields.locality + ', ' + fields.country;
                if (fields.street_number) {
                  fullAddress = fields.route + ', ' + fields.street_number + ', ' + fields.locality + ', ' + fields.country;
                }
                _this._geoSuggest.update(fullAddress);

                _this.timeout = setTimeout(function () {
                  _this.timeout && clearTimeout(_this.timeout);
                  _this._geoSuggest.selectSuggest();
                }, 1500);
              });
            }
          }),
          errorMap[item.label] && _react2.default.createElement(
            'span',
            { style: _extends({}, styles.error) },
            errorMap[item.label]
          )
        );
      });

      return _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(_framework7React.ListItem, { divider: true, style: { height: '1px' } }),
        singleFieldList
      );
    };

    Geosuggest = require('react-geosuggest').default;
    require('./geosuggest.css');

    _this.state = {
      fields: {}
    };
    return _this;
  }

  _createClass(LocationInput, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var addressFields = this.props.items.filter(function (item) {
        return ['lat', 'lng'].indexOf(item.locationField) < 0;
      });

      return _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
          _framework7React.ListItem,
          null,
          _react2.default.createElement(Geosuggest, {
            ref: function ref(el) {
              if (!_this2._geoSuggest) {
                _this2._geoSuggest = el;el.selectSuggest();
              }
            },
            placeholder: 'Cerca indirizzo di consegna',
            types: this.props.suggestionTypes,
            initialValue: this.props.initialValue,
            onSuggestSelect: this.onSuggestSelect,
            onUpdateSuggests: this.onUpdateSuggests,
            style: _extends({}, styles.geosuggest)
          })
        ),
        //this.state.showForm && // hide when suggestions are open
        this.renderSingleFieldSections(addressFields)
      );
    }
  }]);

  return LocationInput;
}(_react.Component);

LocationInput.propTypes = {
  label: _propTypes2.default.string,
  items: _propTypes2.default.arrayOf(_propTypes2.default.object),
  initialValue: _propTypes2.default.string,
  onChange: _propTypes2.default.func.isRequired,
  errors: _propTypes2.default.array,
  country: _propTypes2.default.string,
  suggestionTypes: _propTypes2.default.arrayOf(_propTypes2.default.string),
  customClassNames: _propTypes2.default.arrayOf(_propTypes2.default.string),
  hidden: _propTypes2.default.bool
};
LocationInput.defaultProps = {
  errors: []
};

exports.LocationInput = LocationInput;

// {
//   this.props.errors && this.props.errors.length > 0 &&
//   <label className="ui red basic label">
//     {this.props.errors.map((error, key) => <div key={key}>{error}</div>)}
//   </label>
// }


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/arreeba-form/lib/components-framework7/LocationInput.js
// module id = 288
// module chunks = 0